import React from 'react';
import {Link as RouterLink} from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';
import {AppBar, Toolbar, Typography} from '@mui/material';

const useStyles = makeStyles()((theme) => {
   return {
   root: {
      boxShadow: 'none'
   },
   quoteText: {
      color: theme.palette.white
   }
   };
 });

const Topbar = props => {
   const {sx, ...rest} = props;
   const {classes}=useStyles()
   return (
      <AppBar {...rest} className={classes.root} sx={{ ...sx}} color="primary" position="fixed">
         <Toolbar>
            <RouterLink to="/">
               <Typography className={classes.quoteText} variant="h4">
                  Sistema DsKey - Llaves Virtuales
               </Typography>
            </RouterLink>
         </Toolbar>
      </AppBar>
   );
};

Topbar.propTypes = {
   sx: PropTypes.string
};

export default Topbar;
